/**
 *アプリケーションのメッセージ管理を行う.
 *
 * @author Nakagawa_Michio@ogis-ri.co.jp
 *
 * 使い方
 *
 * 以下の宣言を行い、messageSource.getMessage('key') でメッセージを取得できる.
 * declare var messageSource: any;
 */

import MessageSource from '../context/resource/MessageSource'

const messages: object = {
  'ja':{
    'common.yes': 'はい',
    'common.no': 'いいえ',
    'send.notifyLabel': 'ファイルダウンロード通知',
    'send.notifyYes': '通知を受ける',
    'send.notifyNo': '通知を受けない',
    'send.yes' : 'はい',
    'send.deleteFile': 'ファイル削除',
    'send.delete' : '削除',
    'send.email': 'メールアドレス',
    'send.name': '氏名',
    'send.mailLang': 'メール送信時の言語',
    'send.filename': 'ファイル名',
    'address.deleteAll': '選択したアドレスを削除しますか？',
    'addressBulk.readError': 'ファイルの読み込みに失敗しました',
    'addressBulk.invalidFile': 'ファイルが不正です',
    'addressBulk.invalidAddress': 'ファイル内のデータが不正です',
    'addressBulk.invalidEmail': 'ファイル内のメールアドレスが重複しています',
    'addressBulk.invalidAddressSize': '登録可能な件数を超えています',
    'addressBulk.success': '処理を受け付けました',
    'sendfilerequest.revokeAll': '選択した宛先のダウンロードURLを無効化しますか？',
    'replyfilerequest.revokeAll': '選択した宛先のアップロードURLを無効化しますか？',
    'accountList.deleteAll': '選択したアカウントを削除しますか？',
    'accountList.deleteAll.attention': '注意：<br>「すべて選択」をクリックして選択された場合、<br>表示されていないページの項目も選択されています。<br>選択された項目がすべて削除されます。<br>本当に削除しますか？',
    'accountList.resetPasswordAll': '選択したアカウントのパスワード再発行をしますか？',
    'accountList.resetPasswordAll.attention': '注意：<br>「すべて選択」をクリックして選択された場合、<br>表示されていないページの項目も選択されています。<br>選択された項目がすべてパスワード再発行されます。<br>本当にパスワード再発行しますか？',
    'accountList.issueAPITokensAll': '選択したアカウントにAPIトークンを発行をしますか？',
    'accountList.issueAPITokensAll.attention': '注意：<br>「すべて選択」をクリックして選択された場合、<br>表示されていないページの項目も選択されています。<br>新規に発行されるトークンの有効期限は{0}日です。',
    'accountList.issueAPITokensAll.canIssueForUSERRoleAccount': 'APIトークンは一般利用者にのみ発行できます。',
    'accountBulk.readError': 'ファイルの読み込みに失敗しました',
    'accountBulk.invalidFile': 'ファイルが不正です',
    'accountBulk.invalidAccount': 'ファイル内のデータが不正です',
    'accountBulk.invalidLoginId': 'ファイル内のログインIDが重複しています',
    'accountBulk.success': '処理を受け付けました',
    'systemLogo.success': 'ロゴ画像のアップロードが完了しました',
    'systemLogo.unsupportFormat': 'サポートされないファイル形式です',
    'systemLogo.readError': 'ファイルの読み込みに失敗しました',
    'systemDomain.delete': '{0} を削除しますか？',
    'systemLimitDomain.delete': '{0} を削除しますか？',
    'systemGuestDomain.delete': '{0} を削除しますか？',
    'systemLimitIpAddress.delete': '{0} を削除しますか？',
    'manageApiTokenList.expire': 'トークンを失効しますか？',
    'manageApiTokenList.expire.attention': '失効したトークンは利用できなくなります。',
    'manageApiTokenList.delete': 'このトークンは既に有効期限切れです。削除しますか？',
    'manageApiTokenList.delete.attention': ' ',
    'usage.fileTransferAlert.conditionDetails': '条件表示',
    'usage.fileTransferAlert.conditionDetailsPreText': '次の条件のいずれかにマッチ。',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.guest': '一時利用者',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.user': '一般利用者',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminAudit': '監査者',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminUser': 'ユーザ管理者',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminSystem': 'システム管理者',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminRoot': 'ルート管理者',
  },
  'en':{
    'common.yes': 'Yes',
    'common.no': 'No',
    'send.notifyLabel': 'File Download Notification',
    'send.notifyYes': 'Receive Notice',
    'send.notifyNo': 'Don\'t receive notice',
    'send.yes' : 'Yes',
    'send.deleteFile': 'Remove file',
    'send.delete' : 'Remove',
    'send.email': 'E-mail Address',
    'send.name': 'Name',
    'send.mailLang': 'Language When Sending E-mail',
    'send.filename': 'File Name',
    'address.deleteAll': 'Remove selected address?',
    'addressBulk.readError': 'Failed to load file',
    'addressBulk.invalidFile': 'The file is invalid',
    'addressBulk.invalidAddress': 'The data in the file is invalid',
    'addressBulk.invalidEmail': 'The e-mail address in the file is duplicated',
    'addressBulk.invalidAddressSize': 'The number of items that can be registered has been exceeded.',
    'addressBulk.success': 'Accepted action',
    'sendfilerequest.revokeAll': 'Disable Download URLs for selected destinations?',
    'replyfilerequest.revokeAll': 'Disable Upload URLs for selected destinations?',
    'accountList.deleteAll': 'Remove selected account?',
    'accountList.deleteAll.attention': 'Note: <br>If Select all is clicked and selected, the items on the pages that are not displayed are also selected. <br> All the selected items are removed. <br>Are you sure you want to remove?',
    'accountList.resetPasswordAll': 'Do you want to reissue the password for the selected account?',
    'accountList.resetPasswordAll.attention': 'Note: <br> If Select all is clicked and selected, the items on the pages that are not displayed are also selected.<br> All the selected items are reissued with the password. <br>True password reissue?',
    'accountList.issueAPITokensAll': 'Do you want to issue API tokens to the selected accounts?',
    'accountList.issueAPITokensAll.attention': 'Note: <br> If Select all is clicked and selected, the items on the pages that are not displayed are also selected.<br> Newly issued tokens are valid for {0} days.',
    'accountList.issueAPITokensAll.canIssueForUSERRoleAccount': 'API tokens can only be issued to User Account.',
    'accountBulk.readError': 'Failed to load file',
    'accountBulk.invalidFile': 'The file is invalid',
    'accountBulk.invalidAccount': 'The data in the file is invalid',
    'accountBulk.invalidLoginId': 'The login IDs in the file are duplicated',
    'accountBulk.success': 'Accepted action',
    'systemLogo.success': 'The logo image upload is complete',
    'systemLogo.unsupportFormat': 'Unsupported file format',
    'systemLogo.readError': 'Failed to load file',
    'systemDomain.delete': 'Do you want to remove {0}?',
    'systemLimitDomain.delete': 'Do you want to remove {0}?',
    'systemGuestDomain.delete': 'Do you want to remove {0}?',
    'systemLimitIpAddress.delete': 'Do you want to remove {0}?',
    'manageApiTokenList.expire': 'Do you want to expire the token?',
    'manageApiTokenList.expire.attention': 'Expired tokens will no longer be available.',
    'manageApiTokenList.delete': 'This token has already expired. Do you want to remove it?',
    'manageApiTokenList.delete.attention': ' ',
    'usage.fileTransferAlert.conditionDetails': 'conditional expression',
    'usage.fileTransferAlert.conditionDetailsPreText': 'Match one of the following conditions.',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.guest': 'Temporary User',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.user': 'User',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminAudit': 'Auditor',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminUser': 'User Administrator',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminSystem': 'System Administrator',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminRoot': 'Root Administrator',
  },
  "zh":{
    'common.yes': '是',
    'common.no': '否',
    'send.notifyLabel': '需要文件下载通知',
    'send.notifyYes': '收到通知',
    'send.notifyNo': '不收到通知',
    'send.yes' : '是',
    'send.deleteFile': '删除文件',
    'send.delete' : '删除',
    'send.email': '邮件地址',
    'send.name': '姓名',
    'send.mailLang': '邮件语言',
    'send.filename': '文件名',
    'address.deleteAll': '删除所选地址吗？',
    'addressBulk.readError': '未能读取文件',
    'addressBulk.invalidFile': '文件无效',
    'addressBulk.invalidAddress': '文件内的数据不正当',
    'addressBulk.invalidEmail': '文件内的电邮地址重叠',
    'addressBulk.invalidAddressSize': '超过可注册数目',
    'addressBulk.success': '接受处理',
    'sendfilerequest.revokeAll': '禁用选定目标的下载URL吗？',
    'replyfilerequest.revokeAll': '禁用所选目标的上载URL吗？',
    'accountList.deleteAll': '是否删除选定的帐户？',
    'accountList.deleteAll.attention': '注意事项:<br>单击“全选”将其选中，<br>未显示的页面上的项目也被选定。<br>删除所有选定的项目。<br>确实要删除吗？',
    'accountList.resetPasswordAll': '是否要为所选帐户重新发布密码？',
    'accountList.resetPasswordAll.attention': '注意事项:<br>单击“全选”将其选中，<br>未显示的页面上的项目也被选定。<br>将重新发出所有选定项的密码。<br>您确定要重新发出密码吗？',
    'accountList.issueAPITokensAll': '你想向选定的账户发放API令牌吗？',
    'accountList.issueAPITokensAll.attention': '注意事项:<br>单击“全选”将其选中，<br>未显示的页面上的项目也被选定。<br>将重新发出所有选定项的密码。<br>新发行的令牌有效期为{0}天。',
    'accountList.issueAPITokensAll.canIssueForUSERRoleAccount': 'API令牌只能发放给普通用户。',
    'accountBulk.readError': '未能读入',
    'accountBulk.invalidFile': '文件无效',
    'accountBulk.invalidAccount': '文件内的数据属欺诈',
    'accountBulk.invalidLoginId': '文件登录标识重叠',
    'accountBulk.success': '已接受处理',
    'systemLogo.success': '徽标图像上传完成',
    'systemLogo.unsupportFormat': '不支持的文件格式',
    'systemLogo.readError': '未能读入',
    'systemDomain.delete': '是否要删除 {0}？',
    'systemLimitDomain.delete': '是否要删除 {0}？',
    'systemGuestDomain.delete': '是否要删除 {0}？',
    'systemLimitIpAddress.delete': '是否要删除 {0}？',
    'manageApiTokenList.expire': '是否要撤销令牌？',
    'manageApiTokenList.expire.attention': '过期的令牌将不可用。',
    'manageApiTokenList.delete': '此标记已过期。是否确实要删除？',
    'manageApiTokenList.delete.attention': ' ',
    'usage.fileTransferAlert.conditionDetails': '条件显示',
    'usage.fileTransferAlert.conditionDetailsPreText': '匹配以下条件之一。',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.guest': '临时用户',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.user': '普通用户',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminAudit': '审计者',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminUser': '用户管理员',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminSystem': '系统管理员',
    'jp.co.ogis_ri.ofs.domain.model.account.RoleType.adminRoot': '根管理员',
  },
}

switch ($('html').attr('lang')) {
  case 'ja':
  case 'zh':
    (window as any).messageSource = new MessageSource(messages, ($('html').attr('lang') as string))
    break
  default:
    (window as any).messageSource = new MessageSource(messages, 'en')
}
